
var Relation = function (symbol, lhs, rhs, lhsunit = null, rhsunit = null) {
  this.symbol = symbol
  this.lhs = lhs
  this.rhs = rhs
  this.lhsunit = lhsunit
  this.rhsunit = rhsunit
}

Relation.prototype.toHTML = function () {
  var lhsHTML = typeof this.lhs.toHTML === 'undefined' ? this.lhsString() : this.lhs.toHTML()
  var rhsHTML = typeof this.rhs.toHTML === 'undefined' ? this.rhsString() : this.rhs.toHTML()

  return lhsHTML + ' ' + this.symbol + ' ' + rhsHTML
}

Relation.prototype.toString = function () {
  return this.lhsString() + ' ' + this.symbol + ' ' + this.rhsString()
}

Relation.prototype.lhsString = function () {
  if (!this.lhsunit) return this.lhs.toString()
  return this.lhs.toString() + this.lhsunit
}

Relation.prototype.rhsString = function () {
  if (!this.rhsunit) return this.rhs.toString()
  return this.rhs.toString() + this.rhsunit
}
export default Relation



// WEBPACK FOOTER //
// ./src/math/types/relation.js